import { render, staticRenderFns } from "./Correspondence.vue?vue&type=template&id=70324590&"
import script from "./Correspondence.vue?vue&type=script&lang=js&"
export * from "./Correspondence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports